import { useEffect, useRef, useState } from "react";

// Stands in for the tooltip provider's hover delay while the root is unmounted.
const ARM_DELAY_MS = 200;

// Dense grids mount hundreds of tooltip triggers, and a Radix root costs ~200ms
// for content at most one of them will ever show. Arming on hover keeps the root
// unmounted until the cursor settles.
const useArmedTooltip = () => {
  const [armed, setArmed] = useState(false);
  const armTimer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(armTimer.current), []);

  const arm = () => {
    clearTimeout(armTimer.current);
    armTimer.current = setTimeout(() => setArmed(true), ARM_DELAY_MS);
  };

  const disarm = () => {
    clearTimeout(armTimer.current);
    setArmed(false);
  };

  return { armed, arm, disarm };
};

export default useArmedTooltip;
